import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Invoice } from '../../models';
import { ApiService } from '../../utils';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class InvoiceService {

  path = 'invoices';

  constructor(
    private apiService: ApiService,
  ) {
  }

  save(invoice): Observable<any> {
    return this.apiService.post(this.path, invoice);
  }

  /**
   * Search invoices from MyInvoice Storage
   *
   * @param params Parameters of the request, to help user narrow results
   */
  search(params: HttpParams): Observable<Invoice[]> {
    return of([]);
    // return this.apiService.get(`${this.path}/search`, params)
    //   .pipe(map(data => data.map(obj => new Invoice(obj))));
  }
}
